import { getClient } from 'api'
import { Choice } from 'components/Input/ChoiceGroup'
import { Unit } from 'components/Input/Text'
import { Config } from 'config/config.interface'
import { CONFIG_AS24_TEST } from 'config/utils/config'
import { BestOfferResponse } from 'hooks/useBestOffer'

export type As24TestName = 'trust' | 'nopurpose'

export const AS24_TEST_ID_SEALS: As24TestName = 'trust'
export const AS24_TEST_ID_NOPURP: As24TestName = 'nopurpose'
export const AS24_CURRENT_TESTS: As24TestName[] = [
  AS24_TEST_ID_SEALS,
  AS24_TEST_ID_NOPURP
]

export async function fetchRatesForSelectOptions(
  options: Choice<number>[],
  advertisementId: string,
  amount: number
): Promise<Choice<number>[]> {
  if (!options.length || !advertisementId) return options

  const client = getClient('paas')
  const operations = options.map((option) => {
    return client.get<BestOfferResponse>(`bestoffer/${advertisementId}`, {
      params: {
        amount,
        term: option.value,
        purpose: 'PRE_OWNED_CAR'
      }
    })
  })

  try {
    return (await Promise.all(operations)).map((response, i) => {
      const rate = `${
        response?.data?.result?.bestOffer?.monthlyRate?.toFixed(2) || ''
      } ${Unit.EURO}`

      return {
        hint: rate,
        value: options?.[i]?.value,
        label: options?.[i]?.label
      }
    })
  } catch (e) {
    return options
  }
}

export const isAs24TestVariant = (
  config: Config,
  // eslint-disable-next-line default-param-last
  testParamName: string | undefined = '',
  testIdentifier: As24TestName
): boolean => {
  return config.name === CONFIG_AS24_TEST && testParamName === testIdentifier
}

export const isAnyAs24TestVariant = (
  config: Config,
  testIdentifier: As24TestName | undefined
): boolean => {
  return (
    config.name === CONFIG_AS24_TEST &&
    !!testIdentifier &&
    AS24_CURRENT_TESTS.includes(testIdentifier)
  )
}
